/* sdk红包活动 暂未处理ts类型
 * @Author: WJL
 * @Date: 2020-04-27 11:56:16
 * @Last Modified by: wjl
 * @Last Modified time: 2022-09-06 20:49:20
 */
import { getReceiveInfo } from '@/api/activity';
import { setStorage, getStorage } from '@/libs/utils';
import {
  handleTitle,
  handleTitleV2,
  handleConditionUnit,
  handlePrice,
  handleConditionType,
  handleOperator
} from '@/libs/business/red-envelope';
import _ from 'lodash';
import moment from 'moment';

const DEFAULT_TYPE_LIST = [
  {
    type: 1,
    text: '等级红包'
  },
  {
    type: 2,
    text: '充值红包'
  },
  {
    type: 3,
    text: '战力红包'
  },
  {
    type: 4,
    text: '高级红包'
  },
  {
    type: 0,
    text: '登录红包'
  },
];
const DEFAULT_TYPE_LIST_V2 = [
  {
    type: 1,
    text: '等级红包'
  },
  {
    type: 2,
    text: '充值红包'
  },
  {
    type: 3,
    text: '高级红包'
  },
  {
    type: 4,
    text: '登录红包'
  },
];

const state = {
  receive_info: {},
  packets: {
    0: [],
    1: [],
    2: [],
    3: [],
    4: []
  },
  bridgeInitFlag: 0,
  role: {},
  typeList: [],
  conditionList: []
};

const mutations = {
  CHANGE_STATE: (state, obj) => {
    state = Object.assign(state, obj);
  },
  /** 处理tab类型归属  1等级 2充值（角色的充值） 3战力 4其他（同时拥有两种或两种不同条件类型限制以上归为其他）
   *  若当前列表无某种类型 则不限制该tab
   */
  HANDLE_CONDITION_TYPE: (state, packets) => {
    if (!packets) return;
    let typeList = [];
    const typeIndexList = [0, 0, 0];
    let packetsObj = {
      0: [],
      1: [],
      2: [],
      3: [],
      4: []
    };
    packets.map((packet, index) => {
      if (!index) {
        // 第一个为创角红包，单独拎出来后面加到排序第一个TAB里
        packetsObj[0] = [packet];
        return;
      }
      const { sub_conditions } = packet;
      let subConditionSet = new Set();
      sub_conditions.map((subCondition) => {
        subConditionSet.add(subCondition.condition_type);
      });
      if (subConditionSet.size > 1) {
        // 超过两种条件限制 归类为其他红包
        packetsObj[4].push(packet);
      } else {
        typeIndexList[[...subConditionSet][0] - 1] =
          typeIndexList[[...subConditionSet][0] - 1] + 1;
        packetsObj[Array.from(subConditionSet)[0]].push(packet)
      }
    });
    state.packets = packetsObj;

    DEFAULT_TYPE_LIST.map(item => {
      if (packetsObj[item.type].length) {
        typeList.push(item)
      }
    })
    
    state.typeList = typeList;
  },
  HANDLE_CONDITION_TYPE_V2: (state, packets) => {
    if (!packets) return;
    let typeList = [];
    let packetsObj = {
      1: [],
      2: [],
      3: [],
      4: []
    };
    packets.map((packet, index) => {
      const type = DEFAULT_TYPE_LIST_V2.find(item => item.type == packet.rule_type);
      const typeFlag = typeList.find(item => item.type == packet.rule_type);
      console.log(typeFlag)
      if (!typeFlag) typeList.push(type);
      packetsObj[packet.rule_type].push(packet)
    });
    state.typeList = typeList;

    for (let [key, val] of Object.entries(packetsObj)) {
      packetsObj[key] = val.sort((a, b) => {
        if (a.apply_status == 1 && b.apply_status == 0) {
          return -1;
        } else if (a.apply_status == 1 && b.apply_status == 2) {
          return -1
        } else if (a.apply_status == 1 && b.apply_status == 3) {
          return -1
        } else if (a.apply_status == 1 && b.apply_status == 1) {
          if (moment(a.reach_time).diff(moment(b.reach_time)) >= 0) {
            return -1
          } else {
            return 1
          }
        } else if (a.apply_status == 0 && b.apply_status == 1) {
          return 1
        } else if (a.apply_status == 0 && b.apply_status == 2) {
          return -1
        }  else if (a.apply_status == 0 && b.apply_status == 3) {
          return -1
        } else if (a.apply_status == 0 && b.apply_status == 0) {
          return 1
        } else if (a.apply_status == 2 && b.apply_status == 0) {
          return 1
        } else if (a.apply_status == 2 && b.apply_status == 1) {
          return 1
        } else if (a.apply_status == 2 && b.apply_status == 3) {
          return -1
        } else if (a.apply_status == 2 && b.apply_status == 2) {
          if (moment(a.receive_time).diff(moment(b.receive_time)) <= 0) {
            return -1
          } else {
            return 1
          }
        } else if (a.apply_status == 3 && b.apply_status == 0) {
          return 1
        } else if (a.apply_status == 3 && b.apply_status == 1) {
          return 1
        } else if (a.apply_status == 3 && b.apply_status == 2) {
          return 1
        } else if (a.apply_status == 3 && b.apply_status == 3) {
          if (moment(a.limit_threshold).diff(moment(b.limit_threshold)) <= 0) {
            return -1
          } else {
            return 1
          }
        }

      })
    }
    console.log(191, packetsObj, typeList)
    state.packets = packetsObj;
  },
  /** 处理领取条件介绍页列表
   */
  HANDLE_CONDITION_TEXT: (state, packets) => {
    if (!packets || !packets.length) return;
    let conditionList = [];
    try {
      // 旧版红包逻辑 
      if (state.receive_info.version == 1) {
        // 第一条目前一定是创角或首充
        let fType = packets[0].sub_conditions[0].condition_type === 1;
        conditionList.push({
          type: fType ? 'level' : 'pay',
          moneyText: '首充',
          dateline: '创角',
          award: `${handlePrice(packets[0])}元现金`,
          money_options: packets[0].money_options
        });

      }
      packets.map((packet, index) => {
        if (index === 0 && state.receive_info.version == 1) return;
        conditionList.push({
          dateline: `${ state.receive_info.version == 2 ? '创角' : '注册' }${packet.limit_threshold}天内`,
          condition:state.receive_info.version == 2 ? handleTitleV2(packet) : handleTitle(packet),
          award: `${handlePrice(packet)}元现金`,
          money_options: packet.money_options
        });
      });
      state.conditionList = conditionList;
    } catch (error) {
      console.log(83, error);
    }
  }
};

const actions = {
  async getReceiveInfo({ commit, state, rootState }, payload) {
    setStorage('activity_status', 0);
    const r = await getReceiveInfo(payload.params);
    setStorage('activity_status', 1);
    commit('suspend/SET_TAB', { action: 'show', val: 'welfare' }, { root: true });
    const appkey = getStorage('appkey');
    const tabs =  rootState.suspend.tabs;
    if (appkey == '200016441') {
      setTimeout(() => {
        commit('suspend/CHANGE_STATE', { activeTab: tabs.find(item => item.type == 'welfare') }, { root: true })
      }, 500)
    }
    commit('CHANGE_STATE', { receive_info: r.content });
    if (r.content.version == 2) {
      commit('HANDLE_CONDITION_TYPE_V2', r.content.packets);
    } else {
      commit('HANDLE_CONDITION_TYPE', r.content.packets);
    }
    commit('HANDLE_CONDITION_TEXT', r.content.packets);
    const hintFlag = r.content.packets.find(packet => packet.apply_status == 1);
    if (hintFlag) commit('suspend/SET_TAB_HINT', { tabType: 'welfare', hintType: true }, { root: true });
    payload.success && payload.success();
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
